<ng-container *ngIf="isVisible">

    <label class="approval-list-label" *ngIf="!isModal">{{ 'COMMON.APPROVAL_LIST.PREVIOUS_APPROVALS' | translate }}</label>

    <!-- Escritorio y tablet: tabla -->
    <div class="approval-list-table">
        <ngx-datatable [rows]="approvalList"
            [rowHeight]="'auto'" class="bootstrap core-bootstrap table-panel" [columnMode]="ColumnMode.flex" [headerHeight]="'auto'"
            [limit]="5" [footerHeight]="50" [externalPaging]="false" [count]="approvalList.length" [scrollbarH]="true"
            [messages]="{ emptyMessage: ('COMMON.LABEL.NO_RESULTS' | translate), totalMessage: '' }">

            <ngx-datatable-column name="{{'COMMON.APPROVAL_LIST.USER' | translate}}" prop="createdUser" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="table-panel-title">{{ userName(row) }}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'COMMON.APPROVAL_LIST.DATE' | translate}}" prop="createdAt" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.createdAt | date:'dd/MM/yy' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'COMMON.APPROVAL_LIST.COMMENT' | translate}}" prop="comment" [flexGrow]="2">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="text-wrap text-break">{{ row.comment | translateField: { obj: row, property: 'comment' } }}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'COMMON.APPROVAL_LIST.ACTION' | translate}}" prop="action" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="approval-list-action-badge" [class.is-rejected]="!row.isValid">
                        <lucide-icon [name]="row.isValid ? 'circle-check' : 'circle-x'" [size]="14"></lucide-icon>
                        <span>{{ row.isValid ? ('COMMON.APPROVAL_LIST.APPROVED' | translate) : ('COMMON.APPROVAL_LIST.REJECTED' | translate) }}</span>
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'COMMON.APPROVAL_LIST.OLD_STATUS' | translate}}" prop="oldStatus" [flexGrow]="1"
                *ngIf="isModal">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="badge badge-pill badge-light-primary">
                        {{row.isValid ? (row.oldStatus.name | translateField: { obj: row.oldStatus, property: 'name' } ) : '-'}}
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'COMMON.APPROVAL_LIST.NEW_STATUS' | translate}}" prop="newStatus" [flexGrow]="1"
                *ngIf="isModal">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="badge badge-pill badge-light-primary">
                        {{row.isValid ? (row.newStatus.name | translateField: { obj: row.newStatus, property: 'name' } ) : '-'}}
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{'COMMON.APPROVAL_LIST.STATUS' | translate}}" prop="status" [flexGrow]="1"
                *ngIf="isModal">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="badge badge-pill" [ngClass]="{'badge-light-danger': row.status.code === 'ANU', 'badge-light-info': row.status.code === 'ACT'}">
                        {{ row.status.name | translateField: { obj: row.status, property: 'name' } }}
                    </div>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>

    <!-- Teléfono: una tarjeta por aprobación, sin scroll horizontal -->
    <div class="approval-list-cards">
        <div class="approval-list-empty" *ngIf="approvalList.length === 0">{{ 'COMMON.LABEL.NO_RESULTS' | translate }}</div>

        <article class="approval-list-card" *ngFor="let row of approvalList">
            <header class="approval-list-card__header">
                <div class="approval-list-card__who">
                    <span class="approval-list-card__user">{{ userName(row) }}</span>
                    <span class="approval-list-card__date">{{ row.createdAt | date:'dd/MM/yy' }}</span>
                </div>
                <span class="approval-list-action-badge" [class.is-rejected]="!row.isValid">
                    <lucide-icon [name]="row.isValid ? 'circle-check' : 'circle-x'" [size]="14"></lucide-icon>
                    <span>{{ row.isValid ? ('COMMON.APPROVAL_LIST.APPROVED' | translate) : ('COMMON.APPROVAL_LIST.REJECTED' | translate) }}</span>
                </span>
            </header>

            <p class="approval-list-card__comment" *ngIf="row.comment">
                {{ row.comment | translateField: { obj: row, property: 'comment' } }}
            </p>

            <dl class="approval-list-card__meta" *ngIf="isModal">
                <div>
                    <dt>{{ 'COMMON.APPROVAL_LIST.OLD_STATUS' | translate }}</dt>
                    <dd><span class="badge badge-pill badge-light-primary">{{ row.isValid ? (row.oldStatus.name | translateField: { obj: row.oldStatus, property: 'name' }) : '-' }}</span></dd>
                </div>
                <div>
                    <dt>{{ 'COMMON.APPROVAL_LIST.NEW_STATUS' | translate }}</dt>
                    <dd><span class="badge badge-pill badge-light-primary">{{ row.isValid ? (row.newStatus.name | translateField: { obj: row.newStatus, property: 'name' }) : '-' }}</span></dd>
                </div>
                <div>
                    <dt>{{ 'COMMON.APPROVAL_LIST.STATUS' | translate }}</dt>
                    <dd><span class="badge badge-pill" [ngClass]="{'badge-light-danger': row.status.code === 'ANU', 'badge-light-info': row.status.code === 'ACT'}">{{ row.status.name | translateField: { obj: row.status, property: 'name' } }}</span></dd>
                </div>
            </dl>
        </article>
    </div>

</ng-container>
